import * as firebase from 'firebase';
import StellarSdk from 'stellar-sdk';
import { makePayment } from './stellar';

export const initApp = () => {
    firebase.initializeApp({
        apiKey: "AIzaSyDu8aYdSO7xNDAEQIcTxM1lidjDC3XLbAA",
        authDomain: "rojak-hacknyu.firebaseapp.com",
        databaseURL: "https://rojak-hacknyu.firebaseio.com",
        projectId: "rojak-hacknyu",
        storageBucket: "rojak-hacknyu.appspot.com",
        messagingSenderId: "862164944831",
        appId: "1:862164944831:web:b3c93c6058e4926b48c30a"
    });
}

export const sendFund = (sourceId, destId, amount) => {
    var sourceKeypair = null;
    var sourceAsset = null;
    var source = firebase.database().ref('users/'+ sourceId);
      source.on('value', function(snapshot) {
        let val = snapshot.val()
        sourceKeypair = new StellarSdk.Keypair.fromPublicKey(val.publicKey);
        sourceAsset = val.currency;
      });

      var destKeypair = null;
      var destAsset = null;
      var dest = firebase.database().ref('users/'+ destId);
        dest.on('value', function(snapshot) {
          let val = snapshot.val()
          destKeypair = new StellarSdk.Keypair.fromPublicKey(val.publicKey);
          destAsset = val.currency;
        });

    makePayment(sourceKeypair, destKeypair, sourceAsset, destAsset, amount);
    
}

initApp();


// WEBPACK FOOTER //
// ./src/utils/firebase.js